import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { resolveImg } from "../lib/api";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

const load = (key, fallback) => {
  try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; }
};

export function StoreProvider({ children }) {
  const [cart, setCart] = useState(() => load("pa_cart", []));
  const [wishlist, setWishlist] = useState(() => load("pa_wishlist", []));

  useEffect(() => { localStorage.setItem("pa_cart", JSON.stringify(cart)); }, [cart]);
  useEffect(() => { localStorage.setItem("pa_wishlist", JSON.stringify(wishlist)); }, [wishlist]);

  const addToCart = useCallback((product, qty = 1) => {
    setCart((prev) => {
      const exists = prev.find((i) => i.id === product.id);
      if (exists) return prev.map((i) => i.id === product.id ? { ...i, qty: i.qty + qty } : i);
      return [...prev, {
        id: product.id, title: product.title, price: product.price,
        image: resolveImg(product.images?.[0]) || product.image || "", size: product.size, qty,
      }];
    });
    toast.success("Добавено в количката", { description: product.title });
  }, []);

  const removeFromCart = useCallback((id) => setCart((p) => p.filter((i) => i.id !== id)), []);
  const updateQty = useCallback((id, qty) => setCart((p) => p.map((i) => i.id === id ? { ...i, qty: Math.max(1, qty) } : i)), []);
  const clearCart = useCallback(() => setCart([]), []);

  const toggleWishlist = useCallback((product) => {
    setWishlist((prev) => {
      const exists = prev.find((i) => i.id === product.id);
      if (exists) { toast("Премахнато от любими"); return prev.filter((i) => i.id !== product.id); }
      toast.success("Добавено в любими", { description: product.title });
      return [...prev, {
        id: product.id, title: product.title, price: product.price,
        image: resolveImg(product.images?.[0]) || product.image || "", size: product.size, slug: product.slug,
      }];
    });
  }, []);

  const inWishlist = useCallback((id) => wishlist.some((i) => i.id === id), [wishlist]);

  const cartCount = cart.reduce((s, i) => s + i.qty, 0);
  const cartTotal = cart.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <StoreContext.Provider value={{
      cart, wishlist, addToCart, removeFromCart, updateQty, clearCart,
      toggleWishlist, inWishlist, cartCount, cartTotal,
    }}>
      {children}
    </StoreContext.Provider>
  );
}
